import {RenderingServices, utils} from '@wallaby-ui/core';

export default function localizedTextComparator(
  valueA,
  valueB,
  nodeA,
  nodeB,
  isInverted,
  services: RenderingServices = {}
) {
  const {intl} = services;
  let result;
  if (intl) {
    const translatedValueA = utils.TranslateUtils.hasTranslation(valueA, intl)
      ? utils.TranslateUtils.translate(valueA, intl)
      : valueA;
    const translatedValueB = utils.TranslateUtils.hasTranslation(valueB, intl)
      ? utils.TranslateUtils.translate(valueB, intl)
      : valueB;

    if (translatedValueA > translatedValueB) {
      result = 1;
    } else if (translatedValueA < translatedValueB) {
      result = -1;
    } else {
      result = 0;
    }
  }
  return result;
}
